import React from 'react'
import DOMPurify from 'dompurify'
import { isNil } from 'ramda'

import { Nil } from '../../types'
import { isShadowDOMEnabled } from '../../utils/htmlPreviewUtils'
import { HtmlPreviewIFrame, HtmlPreviewIframeProps } from './HtmlPreviewIFrame'
import {
  HtmlPreviewShadowDom,
  HtmlPreviewShadowDomProps,
} from './HtmlPreviewShadowDom'

export interface UseHtmlPreviewProps {
  allowPointerEvents?: boolean
  css?: string
  fontSize?: string
  html?: string | Nil
  iFrameLoaded?: HtmlPreviewIframeProps['iFrameLoaded']
  shadowDomClasses: HtmlPreviewShadowDomProps['classes']
  zoom?: number
}

export const useHtmlPreview = ({
  css,
  html: htmlProp,
  zoom = 100,
  iFrameLoaded,
  shadowDomClasses,
  allowPointerEvents,
  fontSize,
}: UseHtmlPreviewProps) => {
  // Sanitize the HTML to prevent potential XSS attacks
  const html = isNil(htmlProp)
    ? htmlProp
    : DOMPurify.sanitize(htmlProp, {
      FORCE_BODY: true,
      FORBID_TAGS: ['script', 'object', 'embed', 'applet'],
    })

  return isShadowDOMEnabled() ? (
    <HtmlPreviewShadowDom
      allowPointerEvents={allowPointerEvents}
      classes={shadowDomClasses}
      css={css}
      fontSize={fontSize}
      html={html}
      zoom={zoom}
    />
  ) : (
    <HtmlPreviewIFrame
      allowPointerEvents={allowPointerEvents}
      css={css}
      html={html}
      iFrameLoaded={iFrameLoaded}
      iFrameScale={zoom / 100}
      transformOrigin="center top"
    />
  )
}
